import { z } from 'zod';
/**
 * Cửa "có hạn và ước lượng trước khi làm" — APM-EREF-a,
 * docs/plan-estimate-by-reference.md §1.
 *
 * Hàm thuần dùng chung: API chặn bằng nó, web biết trước bằng nó (qua
 * `TaskView.planMissing` do server tính). Một chỗ quyết định thì nút và cửa
 * không thể lệch nhau.
 */
export const PlanField = z.enum(['dueDate', 'estimateHours']);
/**
 * Những trường còn thiếu để việc được sang "đang làm" / "xong". Rỗng = đủ.
 *
 * Mốc (milestone) không áp: nó là một thời điểm, không phải khối công việc, nên
 * không mang giờ ước lượng (APM-TASK-ms2a).
 */
export function planMissing(task) {
    if (task.kind === 'milestone')
        return [];
    const missing = [];
    if (task.dueDate === null || task.dueDate === undefined)
        missing.push('dueDate');
    if (task.subtaskCount === 0 &&
        (task.estimateHours === null || task.estimateHours === undefined)) {
        missing.push('estimateHours');
    }
    return missing;
}
/**
 * Lần chuyển này có phải đi qua cửa không: **vào** cột `in_progress` hoặc `done`.
 * Mở lại việc đã xong thì không — cửa chặn bắt đầu không được cấm sửa sai
 * (cùng lý do với `checkCanStart`).
 */
export function entersWork(fromCategory, toCategory) {
    if (fromCategory === 'done')
        return false;
    if (fromCategory === toCategory)
        return false;
    return toCategory === 'in_progress' || toCategory === 'done';
}
//# sourceMappingURL=task-plan-gate.js.map